var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"staff_item"},[_c('div',{staticClass:"img"},[_vm._t("img")],2),_c('div',{staticClass:"text"},[_vm._t("text")],2),_c('div',{staticClass:"desc"},[_vm._t("desc")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }